import { JUDGE_IS_LOGIN } from '@store/officialTopupNew/login';
import { GET_ACTIVITY_LIST } from '@store/officialTopupNew/activity';
import { GET_SEPC_GAME_INFO } from '@store/officialTopupNew';
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  LOAD_GAME_COUPON_LIST,
  LOAD_VIP_COUPON_INFO
} from '@store/store/coupon';
import { mapGetters } from 'vuex';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import { errorReport404 } from '@utiles/errorReport';
const mainHost = globalConfig.getMainHost();

export const jumpErrorPage = () => {
  let hostName = mainHost;
  if (
    hostName === atob('M3N5dWEuY29t') ||
    hostName === atob('YmxhbmNvem9uZS5jb20=')
  ) {
    // 其实404路径不存在，后端根据ip跳转真实404
    errorReport404();
    window.location.href = getGlobalGetGotoLink({
      link: `//www.${hostName}/404`
    });
  } else if (hostName === atob('c2xmdW50YXAuY29t')) {
    errorReport404();
    window.location.href = getGlobalGetGotoLink({
      link: `//www.${hostName}/slfuntap/page404`
    });
  } else {
    errorReport404();
    window.location.href = getGlobalGetGotoLink({
      link: `//www.${hostName}/page404`
    });
  }
};

export default {
  computed: {},
  methods: {
    globalBeforeCreate() {
      this.$store.dispatch(JUDGE_IS_LOGIN).then(async res => {
        if (!res) {
          this.getActivityList();
          return;
        }
        let canContinue = await this.$store.dispatch(GET_SEPC_GAME_INFO, {
          gameId: this.$store.state.gameId
        });
        if (!canContinue) {
          jumpErrorPage();
        }
        //  2024-04-09 :修复因接口请求顺序错误，导致登录态异常（这个接口也需要登录态，所以登录成功再请求好了）
        this.$store.dispatch(LOAD_GAME_COUPON_LIST);
        // this.$store.dispatch(LOAD_VIP_COUPON_INFO);
      });
    },
    jpBeforeCreate() {
      this.$store.dispatch(JUDGE_IS_LOGIN).then(res => {
        if (!res) {
          this.getActivityList();
          return;
        }
      });
    },
    getActivityList() {
      this.$store.dispatch(GET_ACTIVITY_LIST, {
        pos: ['index_banner', 'popup', 'lamp', 'time_award', 'recommend']
      });
    }
  },
  created() {
    this.$store.getters.isJpPlatform
      ? this.jpBeforeCreate()
      : this.globalBeforeCreate();
  }
};
